import React from 'react'
import { Link } from 'react-router-dom'
import { DataGrid } from '@the-platform-group/component-library/DataGrid'
import { Box, styled, Typography } from '@the-platform-group/component-library'
import { useParams } from 'react-router-dom'
import useChangeScopeMutation from 'hooks/useChangeScopeMutation'
import ScopeChangeAction from 'components/ScopeChangeAction'
import { USER_QUERY_KEY } from 'pages/Users/hooks/useUsers'

const StyledBox = styled(Box)(() => ({ display: 'flex', flexDirection: 'column' }))

export const getColumnValues = ({ changeScopeOfCustomerAuthorization, userName }) => {
  return [
    {
      field: 'customer',
      cellClassName: 'hoverCell',
      renderCell: ({ row }) => {
        const { id, name } = row.customer
        return (
          <StyledBox>
            <Link to={`/accounts/customers/${id}`}>{name}</Link>
            <Typography variant="body2" component="span">
              {id}
            </Typography>
          </StyledBox>
        )
      },
    },
    { field: 'scope' },
    {
      field: 'lockedAt',
      headerName: 'Active',
      valueGetter: ({ row }) => (row.lockedAt ? 'No' : 'Yes'),
    },
    {
      field: 'actions',
      type: 'actions',
      getActions: ({ row }) => {
        const { id, scope, lockedAt } = row
        if (lockedAt) {
          return []
        }
        return [
          <ScopeChangeAction
            name={userName}
            scope={scope}
            authorizationId={id}
            mutation={changeScopeOfCustomerAuthorization}
          />,
        ]
      },
    },
  ]
}

const getRowValues = rowValues => {
  return rowValues.map(row => {
    const { id, customer, lockedAt, scope } = row
    return {
      id: id,
      customer: {
        id: customer.id,
        name: customer.name,
      },
      scope: scope,
      lockedAt: lockedAt,
    }
  })
}

const UserCustomers = ({ user }) => {
  const { customerAuthorizations } = user
  const { id: userId } = useParams()
  const changeScopeOfCustomerAuthorization = useChangeScopeMutation({
    queryKey: [USER_QUERY_KEY, userId],
  })

  return (
    <>
      <Typography variant="h5" component="h2">
        Customers
      </Typography>
      <DataGrid
        name="UserCustomersTable"
        columns={getColumnValues({
          changeScopeOfCustomerAuthorization,
          userName: [user.firstName, user.lastName].join(' '),
        })}
        commonColumnProps={{ headerAlign: 'left' }}
        rows={getRowValues(customerAuthorizations)}
        rowCount={customerAuthorizations.length}
        localeText={{
          noRowsLabel: 'No customers have authorized this user.',
        }}
        sx={{
          '.hoverCell': {
            '&.MuiDataGrid-cell:hover span, &.MuiDataGrid-cell:hover .MuiButtonBase-root': {
              display: 'block',
              fontSize: 11,
            },
            'span, .MuiButtonBase-root': { display: 'none' },
          },
        }}
      />
    </>
  )
}

export default UserCustomers
